import styled from 'styled-components'
import { flexbox, layout, margin, padding } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { BLUEPRINT_WIDTH, PADDING_X } from 'Constants/Landing'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled.div.attrs({
  pt: [6, 6, 6, 6, 15],
  pb: [17, 17, '100px', '120px'],
  px: PADDING_X,
})`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  justify-content: center;
  background-color: ${themeGet('colors.bg.default')};

  ${padding}
`

export const Content = styled.div
  .attrs({
    flexDirection: [
      'column-reverse',
      'column-reverse',
      'column-reverse',
      'column-reverse',
      'row',
    ],
  })
  .withConfig({
    shouldForwardProp,
  })`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: ${BLUEPRINT_WIDTH}px;
  position: relative;

  ${flexbox}
`

export const ImageHolder = styled.div
  .attrs({
    width: [1, 1, 1, 1, 580],
    height: [210, 350, 436, 572],
  })
  .withConfig({
    shouldForwardProp,
  })`
  flex-shrink: 0;
  z-index: 11;
  overflow: hidden;
  border-radius: 20px;

  ${margin}
  ${layout}
`

export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
`

export const DotsContainer = styled.div.attrs({
  display: ['none', 'none', 'flex'],
})`
  bottom: -40px;
  left: 20px;
  position: absolute;
  z-index: 0;

  ${layout}
`
